import ShuttleLayout from "../../components/layout/ShuttleLayout";
import styled from 'styled-components';
import Button from '../../components/Button';
import { useHistory, useLocation } from "react-router-dom";
import QueryString from "qs";
import { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { IGetStudents2, IStudent2 } from "../../models/shuttleSetting.model";
import { getStudentList } from "../../api/shuttleSetting.api";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import { IGetStations } from "../../models/shuttleHelper.model";
import _ from "lodash";
import { Select } from "antd";
import { getStations, sendMessages } from "../../api/shuttleHelper.api";
import useNotification from "../../hooks/useNotification";
import { IGetCurrentSemester, IGetSemesters } from "../../models/semesters.model";
import { getCurrentSemester, getSemesters } from "../../api/semesters.api";
import { useTranslation } from "react-i18next";

const Block = styled.div`
  margin-bottom: 60px;

  table th,
  table td {
    text-align: center;
    padding: 4px 2px;
  }
`;

const ShuttleSearch = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const runningCode = Number(query.runningCode);
  const rideGbn = String(query.rideGbn);
  const date = String(query.date);
  const { successNotification, infoNotification } = useNotification();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetStudents2>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetStations>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetCurrentSemester>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<IGetSemesters>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [data, setData] = useState<IStudent2[]>([]);
  const [inputs, setInputs] = useState<any>([]);
  const [semesterCode, setSemesterCode] = useState<number>();
  const [studentName, setStudentName] = useState('');

  useEffect(() => {
    execute3(getCurrentSemester());
    execute4(getSemesters());
  }, []);

  useEffect(() => {
    if (res3 && !isLoading3 && currentCampus) {
      setSemesterCode(res3.data?.semesterCode);
      execute(getStudentList(currentCampus, res3.data?.semesterCode));
    }
  }, [res3, isLoading3, currentCampus]);

  useEffect(() => {
    if (currentCampus) {
      execute2(getStations(currentCampus, runningCode));
    }
  }, [currentCampus]);

  useEffect(() => {
    if (semesterCode && currentCampus) {
      setStudentName('');
      setData([]);
      execute(getStudentList(currentCampus, semesterCode));
    }
  }, [semesterCode, currentCampus]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      onCancel();
      successNotification(t('shuttle.text.23'));
    }
  }, [submitRes, submitIsLoading]);

  const onSearch = () => {
    if (!res) return;
    let data = _.cloneDeep(res.data);
    data = data.filter(item => item.memKorName?.includes(studentName) || item.memEngName?.includes(studentName));
    setData(data);
  }

  const onCancel = () => {
    setData([]);
    setInputs([]);
    setStudentName('');
  }

  const getInputValue = (memberCode: string, key: string) => {
    const input = inputs.find((item: any) => item.memberCode === memberCode);
    if (!input) return undefined;
    return input[key];
  }

  const onSetInputs = (memberCode: string, key: string, value: string) => {
    const input = inputs.find((item: any) => item.memberCode === memberCode);
    if (input) {
      input[key] = value;
      setInputs([...inputs]);
    } else {
      setInputs([...inputs, { memberCode, [key]: value }]);
    }
  }

  const onSubmit = () => {
    if (inputs.length === 0) {
      return infoNotification(t('shuttle.text.47'));
    }

    for (let i = 0; i < inputs.length; i++) {
      if (!inputs[i].runningStationCode) {
        return infoNotification(t('shuttle.text.48'));
      }
      if (!inputs[i].rideYn) {
        return infoNotification(t('shuttle.text.49'));
      }
    }

    const req: any = [];
    inputs.forEach((item: any) => {
      req.push({
        runningCode,
        runningStationCode: item.runningStationCode,
        memberCode: item.memberCode,
        rideGbn,
        rideYn: item.rideYn,
      });
    })

    submitExecute(sendMessages(currentCampus, req));
  }

  return (
    <ShuttleLayout>
      {isLoading || isLoading2 || isLoading3 || isLoading4 || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={submitError} />

      <Block className="w-100">
        <div className="flex p-2">
          <div className="mr-1">
            <Select
              className="w-100p"
              placeholder={t('shuttle.text.50')}
              value={semesterCode}
              onChange={value => setSemesterCode(value)}
            >
              {res4?.data?.map((item: any) => (
                <Select.Option
                  key={item.semesterCode}
                  value={item.semesterCode}
                >
                  {item.semesterName}
                </Select.Option>
              ))}
            </Select>
          </div>
          <input
            type="text"
            className="form-control"
            placeholder={t('shuttle.text.51')}
            value={studentName}
            onChange={(e) => setStudentName(e.target.value)}
            onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
          />
          <Button
            onClick={onSearch}
            className="btn btn-w55p ml-1 btn-secondary"
            text={t('common.button.search')}
          />
          <Button
            onClick={onCancel}
            className="btn btn-w55p ml-1 btn-secondary"
            text={t('common.button.cancel')}
          />
        </div>
        <div className="mt-3">
          <table className="table-shuttle">
            <colgroup>
              <col width="25%" />
              <col width="50%" />
              <col width="25%" />
            </colgroup>
            <tbody>
              <tr>
                <th>{t('shuttle.text.38')}</th>
                <th>{t('shuttle.text.37')}</th>
                <th>{rideGbn === 'UP' ? t('shuttle.text.8') : t('shuttle.text.9')} {t('shuttle.text.39')}</th>
              </tr>
              {
                data.length > 0
                  ? data.map((item, index) => (
                    <tr>
                      <td className="text-center">
                        {item.memKorName} ({item.webId})
                      </td>
                      <td className="text-center">
                        <div className="w-100">
                          <Select
                            className="w-100"
                            placeholder={t('common.button.select')}
                            value={getInputValue(item.memberCode, 'runningStationCode')}
                            onChange={value => onSetInputs(item.memberCode, 'runningStationCode', value)}
                          >
                            {res2?.data.map(item => (
                              <Select.Option
                                key={item.runningStationCode}
                                value={item.runningStationCode}
                              >
                                {item.stationName}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </td>
                      <td className="text-center">
                        <Button
                          onClick={() => onSetInputs(item.memberCode, 'rideYn', 'Y')}
                          className={'btn btn-sm btn-w70p mr-1 ' + (getInputValue(item.memberCode, 'rideYn') === 'Y' ? 'btn-primary' : 'btn-info')}
                          text={t('shuttle.text.10')}
                        />
                        <Button
                          onClick={() => onSetInputs(item.memberCode, 'rideYn', 'N')}
                          className={'btn btn-sm btn-w70p mr-1 ' + (getInputValue(item.memberCode, 'rideYn') === 'N' ? 'btn-primary' : 'btn-info')}
                          text={t('shuttle.text.27')}
                        />
                      </td>
                    </tr>
                  ))
                  : (
                    <tr>
                      <td className="text-center" colSpan={3}>
                        {t('shuttle.text.52')}
                      </td>
                    </tr>
                  )
              }
            </tbody>
          </table>
        </div>
        <div className="footer">
          <table>
            <colgroup>
              <col width="50%" />
              <col width="50%" />
            </colgroup>
            <tbody>
              <tr>
                <td onClick={() => history.push(`/detail?runningCode=${runningCode}&rideGbn=${rideGbn}&date=${date}`)}>
                  {t('shuttle.text.53')}
                </td>
                <td onClick={onSubmit}>
                  {t('shuttle.text.42')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Block>
    </ShuttleLayout>
  );
}

export default ShuttleSearch;
